import type { PanelHandle } from '../scene/panels';
import { BY_ID } from '../data/system';
import type { ConnectionLayer } from '../scene/connections';

export class HoverManager {
  private panels: Map<string, PanelHandle>;
  private connections: ConnectionLayer;
  private hoveredId: string | null = null;
  onHover?: (id: string | null) => void;

  constructor(panels: PanelHandle[], connections: ConnectionLayer) {
    this.panels = new Map(panels.map((p) => [p.id, p]));
    this.connections = connections;
    for (const p of panels) {
      p.domElement.addEventListener('mouseenter', () => this.enter(p.id));
      p.domElement.addEventListener('mouseleave', () => this.leave(p.id));
    }
  }

  private enter(id: string) {
    if (this.hoveredId === id) return;
    this.hoveredId = id;
    const el = BY_ID[id];
    if (!el) return;

    const relatedIds = new Set<string>([id, ...el.related]);

    for (const [pid, p] of this.panels) {
      p.domElement.classList.remove('related');
      if (pid === id) {
        p.domElement.classList.remove('dim');
      } else if (relatedIds.has(pid)) {
        p.domElement.classList.remove('dim');
        p.domElement.classList.add('related');
      } else {
        p.domElement.classList.add('dim');
      }
    }

    this.connections.showFor(el);
    this.onHover?.(id);
  }

  private leave(id: string) {
    if (this.hoveredId !== id) return;
    this.hoveredId = null;
    for (const p of this.panels.values()) {
      p.domElement.classList.remove('dim', 'related');
    }
    this.connections.hide();
    this.onHover?.(null);
  }
}
